export const STATIC_LINKS = {
  LINKED_IN: 'https://www.linkedin.com/in/nikolaos-pertsilis/',
}
